import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["MazPhoneNumberInput"], {
    modelValue: $setup.phoneValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.phoneValue) = $event)),
    color: "info",
    id: "phone",
    disabled: _ctx.$attrs.disabled,
    "no-example": true,
    search: true,
    onUpdate: $setup.setNumber,
    "no-use-browser-locale": true,
    "no-formatting-as-you-type": true,
    translations: $setup.trans,
    "country-locale": 'en',
    "country-code": $setup.countryCode,
    "no-radius": "",
    label: null,
    hint: null
  }, {
    "selector-flag": _withCtx(({ countryCode }) => [
      _createElementVNode("span", {
        class: _normalizeClass(["fi fis flag-wrap", `fi-${(countryCode).toLowerCase()}`])
      }, null, 2)
    ]),
    "country-list-flag": _withCtx(({ countryCode }) => [
      _createElementVNode("span", {
        class: _normalizeClass(["fi fis flag-wrap", `fi-${(countryCode).toLowerCase()}`])
      }, null, 2)
    ]),
    _: 1
  }, 8, ["modelValue", "disabled", "translations", "country-code"]))
}